import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { format } from "date-fns";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { exportExcel } from "../hooks/useExportUtils";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
export const ListadoEmpleadosEditor = () => {
  const { selectedNomina,setEmpleadoSeleccionado } = useOutletContext();
  const [empleados, setEmpleados] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(50);
  const [globalFilter, setGlobalFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const getData = async () => {
    try {
      const response = await axiosPrivate.get("NOM/humandEmpleados/select");

      const data = response.data;
      console.log(data);
      //setEmpleados(data.simplifiedUsers);
      setEmpleados(data.filteredUsers);
    } catch (error) {
      console.error("Error al obtener empleados:", error);
    }
  };

  //   useEffect(() => {
  //   if (!selectedNomina) return;
  //   getData();
  // }, [selectedNomina]);

  useEffect(() => {
    if (!selectedNomina?.idNomina) return;
    getData();
  }, [selectedNomina?.idNomina]);

  // useEffect(() => {
  //   if (selectedNomina?.idNomina) {
  //     axiosPrivate.get("NOM/empleados/listado/" + selectedNomina.idNomina)
  //       .then((response) => {
  //         console.log("Empleados response:", response.data);
  //         setFaltas(response.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error al obtener empleados:", error);
  //       });
  //   }
  // }, [selectedNomina?.idNomina]);

  const columns = [
    // { field: "id", header: "id", sortable: true },
    // { field: "numeroEmpleado", header: "Número", sortable: true },
    { field: "nombre", header: "Nombre", sortable: true },
    { field: "apellidoPaterno", header: "Paterno", sortable: true },
    { field: "apellidoMaterno", header: "Materno", sortable: true },
    // { field: "employeeInternalId", header: "Apellido materno", sortable: true },
    { field: "rfc", header: "RFC", sortable: true },
    // { field: "curp", header: "CURP", sortable: true },
    { field: "fechaIngreso", header: "Fecha ingreso", sortable: true },
    { field: "status", header: "Estatus", sortable: true },
    { field: "UBICACION", header: "Ubicacion", sortable: false },
    //{ field: "SOCIO_ENCARGADO", header: "Socio", sortable: false },
    //{ field: "PRACTICA", header: "Practica", sortable: false },
    //{ field: "SUBPRACTICA", header: "Subpractica", sortable: false },
    //{ field: "SUBPRACTICA", header: "Nomina", sortable: false },
    // { field: "RFC", header: "RFC" , sortable: true},
    // { field: "CorreoElectronico", header: "Email", sortable: true },
    // { field: "Practica", header: "Practica" , sortable: true},
    // { field: "Puesto", header: "Puesto" , sortable: true},
    // { field: "Region", header: "Region", sortable: false },
    // { field: "Socio", header: "Socio" , sortable: true, filter: false},
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable={col.sortable}
      filter={col.filter}
    />
  ));

  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    ),
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
  const handleBack = () => {
    navigate(-1);
  };
  const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      {/* <label htmlFor="periodo" className="whitespace-nowrap">Filtrar por periodo:</label>
      <Dropdown
        id="periodo"
        // value={periodoSeleccionado}
        // options={periodosDisponibles}
        // onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      /> */}
      <Button
        label="Exportar Excel"
        icon="pi pi-file-excel"
        severity="success"
        onClick={() => exportExcel(empleados, "Faltas")}
      />
      <Button
        icon="pi pi-eye-slash"
        className="p-button-outlined"
        severity="help"
        label="Ocultar empleados"
        tooltip="Ocultar empleados seleccionados"
        onClick={guardarSeleccion}
      />
    </div>
  );

  const rightToolbarTemplate = () => (
    <span className="p-input-icon-left">
      <i className="pi pi-search" />
      <InputText
        type="search"
        placeholder="Buscar..."
        value={globalFilter}
        onChange={(e) => setGlobalFilter(e.target.value)}
        className=" ml-4"
      />
    </span>
  );
  const [selectedEmpleados, setSelectedEmpleados] = useState(null);

  const [rowClick, setRowClick] = useState(true);
  const toast = useRef(null);

  const guardarSeleccion = async () => {
    const idsSeleccionados = selectedEmpleados.map((row) => row.id);
    try {
        console.log("IDs seleccionados:", idsSeleccionados);
      await axiosPrivate.post("/NOM/OcultarEmpleadosHumand", { ids: idsSeleccionados });
      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: "IDs guardados correctamente",
        life: 3000,
      });
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al guardar los datos",
        life: 3000,
      });
    }
  };
    const handleEdit = (empleado) => {
      console.log("Editar:", empleado);
       setEmpleadoSeleccionado(empleado);
      // Aquí podrías navegar a un formulario o abrir un modal
      navigate(`/editor/empleados/transferir`); // ajusta según tu ruta
    };
  
    const handleDelete = (falta) => {
      console.log("Eliminar:", falta);
      confirmDialog({
        message: `¿Estás seguro de eliminar el registro de "${falta.Nombre}"?`,
        header: "Confirmar eliminación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí, eliminar",
        rejectLabel: "Cancelar",
        accept: async () => {
          try {
            await axiosPrivate.delete(`/NOM/excepciones/${falta.id}`);
            toast.current.show({
              severity: "success",
              summary: "Eliminado",
              detail: `Empleado eliminado correctamente`,
              life: 3000,
            });
            getData(); // Recargar empleados
          } catch (error) {
            console.error("Error al eliminar:", error);
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "No se pudo eliminar el empleado",
              life: 3000,
            });
          }
        },
      });
    };
  
    const actionBodyTemplate = (rowData) => {
      return (
        <div className="flex gap-2">
          <Button
            icon="pi pi-arrow-circle-right"
            className="p-button-rounded p-button-secondary p-button-sm"
            onClick={() => handleEdit(rowData)}
            tooltip="Transferir a nomina"
          />
          <Button
            icon="pi pi-eye-slash"
            className="p-button-rounded p-button-help p-button-sm"
            onClick={() => handleDelete(rowData)}
            tooltip="Eliminar"
          />
        </div>
      );
    };
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
      <Card title="Empleados">
        <div className="mb-3 flex justify-content-between">
          <Button
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-secondary"
            onClick={handleBack}
          />
        </div>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        />
        <DataTable
          dataKey="id"
          value={empleados}
          responsiveLayout="scroll"
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          globalFilter={globalFilter}
          className="p-datatable-sm"
          stripedRows
          selectionMode={rowClick ? null : "checkbox"}
          selection={selectedEmpleados}
          onSelectionChange={(e) => setSelectedEmpleados(e.value)}
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
          ></Column>
          {dynamicColumns}
          <Column
                      body={actionBodyTemplate}
                      header="Acciones"
                      style={{ minWidth: "10rem" }}
                    />
        </DataTable>
      </Card>
    </div>
  );
};

export default ListadoEmpleadosEditor;
